module.exports = __webpack_public_path__ + "img/BackgroundCourier.cb02a258.svg";